import SelectDinamico from "../../SelectDinamico";
import ConsultaNatureza from "../../../../lib/json/consultas/Natureza.json"

function SelectNatureza({campoNatureza, changeNatureza, queryNatureza, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, showNoFilter=false, selectOptionUnique=false,isMultiplo=false}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')

    const cConsultaDefault = ConsultaNatureza.consulta + " WHERE D_E_L_E_T_ <> '*' AND ED_FILIAL = FILIAL(SED) AND ED_MSBLQL <> '1' AND ED_TIPO = '2' "
    const consulta = queryNatureza || ( loadDefault ? cConsultaDefault : '' )
    const localEstoqueValue = bindItem ? bindItem[field] : campoNatureza;

    return (
        <SelectDinamico
            label="Natureza"
            cText="ED_CODIGO + ' - ' + item.ED_DESCRIC"
            cValue="ED_CODIGO"
            campoValue={localEstoqueValue}
            consulta={consulta}
            tabela={ConsultaNatureza.tabelas}
            isMultiplo={isMultiplo}
            showNoFilter={showNoFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeNatureza(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
            selectOptionUnique={selectOptionUnique}
        />
    )
}

export default SelectNatureza;